import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import PassTemplate from "../Modals/PassTemplate";
import axios from "axios";
import Spinner from "../Components/Spinner";
import Customer from "../Modals/Customer";
import Error from "../Components/Error";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "country-flag-icons/react/3x2";

import { IoCheckmarkCircleOutline, IoWalletOutline } from "react-icons/io5";
import { SiApple, SiGooglepay } from "react-icons/si";

const CustomerSignup: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [passTemplate, setPassTemplate] = useState<PassTemplate>();
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [customer, setCustomer] = useState<Customer>({
    name: "",
    passTemplateId: passTemplate?.id || "",
    active: false,
    created: new Date(Date.now()),
    email: "",
    phone: "",
    pass: null,
    id: "",
    bDay: null,
  });
  const [countryCode, setCountryCode] = useState("us");
  const [formError, setFormError] = useState("");
  const [isAppleDevice, setIsAppleDevice] = useState(false);
  const [modalHidden,setModalHidden] = useState<boolean>(true)
  const [agreed,setAgreed] = useState<boolean>(false)

  function getImagePath(url?:string){
    if(!url) return ""
    const parsedUrl = new URL(url);

    // Get the pathname (which includes the folder and file name)
    const pathname = parsedUrl.pathname;

    // Extract the folder and file name
    const parts = pathname.split('/');
    const folderName = parts[parts.length - 2];  // "logos"
    const fileName = parts[parts.length - 1];   // "566d8092-af5c-487b-acef-d36bff6bdd1f.png"
    
    return `${process.env.REACT_APP_HOST}Images/${folderName}/${fileName}`;
}
  useEffect(() => {
    const fetchPassTemplate = async () => {
      try {
        const response: PassTemplate = (
          await axios.get(`${process.env.REACT_APP_HOST}PassTemplate/Anonymous/` + id)
        ).data;
        setPassTemplate(response);
       
      } catch (error) {
        setError("Something went wrong getting passTemplate details");
      } finally {
        setIsLoading(false);
      }
    };

    const fetchUserCountry = async () => {
      try {
        const { data } = await axios.get("https://ipapi.co/json/"); // or any IP-based geolocation API
        setCountryCode(data.country_code.toLowerCase());
      } catch (err) {
        console.error("Failed to fetch user country:", err);
      }
    };

    const detectDevice = () => {
      const userAgent = window.navigator.userAgent.toLowerCase();
      setIsAppleDevice(/iphone|ipad|ipod|mac/.test(userAgent));
    };

    fetchPassTemplate();
    fetchUserCountry();
    detectDevice();
  }, [id]);

  const registerCustomer = async () => {
    try {
      setIsLoading(true);
      const response: Customer = (
        await axios.post(`${process.env.REACT_APP_HOST}Customer/`, {
          passTemplateId: passTemplate?.id,
          name: customer.name,
          phone: customer.phone,
          email: customer.email,
        })
      ).data;
      setCustomer(response);
    } catch (error) {
      setError("Something went wrong Registering the Customer");
    } finally {
      setIsLoading(false);
    }
  };

 
  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const cleaned = e.target.value.replace(/[^\d+]/g, '');
    setCustomer({ ...customer, phone: cleaned });
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!customer.phone || customer.phone.length < 10) {
      setFormError("رقم الجوال مطلوب للتسجيل");
      return;
    }

    if (!customer.name || customer.name.length < 3) {
      setFormError("الاسم غير صحيح");
      return;
    }

    if (!agreed ) {
      setFormError("يجب ان توافق بالشروط و الاحكام للتسجيل");
      return;
    }

    setFormError("");
    registerCustomer();
  };

  return (
      isLoading ? (
    <div className="flex flex-col justify-center items-center w-full h-[100vh]">
    <Spinner size={70} loading={isLoading} />
    </div>
      ) : error ? (
        <Error message={error} />
      ) : customer.id ? (
        <div className="min-h-screen w-full bg-gradient-to-br from-brand-50 via-white to-emerald-50 flex items-center justify-center px-4">
      <div
        dir="rtl"
        className="w-full max-w-md bg-white/90 backdrop-blur border border-gray-100 shadow-xl rounded-2xl p-4 sm:p-8 text-center"
      >
        {/* Success icon */}
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-emerald-50">
          <IoCheckmarkCircleOutline className="h-8 w-8 text-emerald-500" />
        </div>

        {/* Title */}
        <h2 className="text-xl font-bold text-gray-900 mb-2">
          تم التسجيل بنجاح 🎉
        </h2>
        <p className="text-sm text-gray-600 mb-6">
          الرجاء حفظ البطاقة في محفظتك للبدء باستخدامها.
        </p>

        

        {/* Action buttons */}
        <div className="space-y-3">
          {isAppleDevice ? (
            <Link
              to={`${process.env.REACT_APP_HOST}Pass/GeneratePassApple/${customer?.id}`}
              className="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-gray-900 px-5 py-2.5 text-sm font-medium text-white shadow-sm hover:bg-black focus:outline-none focus:ring-4 focus:ring-gray-300"
            >
              <p  className="text-sm sm:text-base md:text-lg ">حفظ البطاقة في محفظة</p>

              <SiApple className="h-5 w-5" />
            </Link>
          ) : (
            <Link
              to={`https://pay.google.com/gp/v/save/${customer?.pass?.googleJwtToken}`}
              className="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-blue-600 px-5 py-2.5 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300"
            >
              <p className="text-sm sm:text-base md:text-lg">حفظ البطاقة في محفظة</p>

              <SiGooglepay className="h-10 w-10" />
            </Link>
          )}

          {/* Secondary help text */}
          <p className="text-xs text-gray-500">
            إذا لم يتم الفتح تلقائيًا، تأكد من أنّ تطبيق المحفظة مُثبت ومُحدّث.
          </p>
        </div>
      </div>
    </div>
      ) 
      : (

          <div className="flex flex-col w-full justify-center items-center w-full h-[100vh]">
           <div className="w-[300px] flex flex-col max-h-[800px] justify-between">
           <img className="mb-10" src={getImagePath(passTemplate?.logo)} alt="" />
            <form className="w-full" onSubmit={handleSubmit}>
            
          <div className="mb-5">
            <label
              htmlFor="name"
              className="block mb-2 text-sm font-medium text-gray-900 -white"
            >
              الاسم *
            </label>
            <input
              type="text"
              id="name"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 -gray-700 -gray-600 placeholder-gray-400 -white focus:ring-blue-500 focus:border-blue-500"
              placeholder="عبدالله"
              
              onChange={(e) =>
                setCustomer({ ...customer, name: e.target.value })
              }
            />
          </div>
          <div className="mb-5">
            <label
              htmlFor="email"
              className="block mb-2 text-sm font-medium text-gray-900 -white"
            >
              البريد الإلكتروني (ليس اجباري)
            </label>
            <input
              type="email"
              id="email"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 -gray-700 -gray-600 placeholder-gray-400 -white focus:ring-blue-500 focus:border-blue-500"
              placeholder="name@roaait.com"
              onChange={(e) =>
                setCustomer({ ...customer, email: e.target.value })
              }
            />
          </div>

          <div className="mb-5">
            <label
              htmlFor="phone-input"
              className="block mb-2 text-sm font-medium text-gray-900 -white"
            >
              رقم الجوال *
            </label>
             <input
            type="tel"
            id="phone"
            name="phone"
            dir="rtl"
            maxLength={10}
            value={customer.phone}
            onChange={handlePhoneChange}
            placeholder="0553608481"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 -gray-700 -gray-600 placeholder-gray-400 -white focus:ring-blue-500 focus:border-blue-500"
          />
              
            
            
            {formError && (
              <p className="mt-2 text-sm text-red-600 -red-500">
                {formError}
              </p>
            )}
          </div>

          <div className="flex items-start mb-5">
            <div className="flex items-center h-5">
              <input
                id="remember"
                type="checkbox"
                checked={agreed}
                className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-blue-300 -gray-700 -gray-600 focus:ring-blue-600 ring-offset-gray-800 focus:ring-offset-gray-800"
                onClick={(e)=>{setAgreed((current:boolean)=> !current)}}
              />
            </div>
            <label
              htmlFor="remember"
              className="ms-2 text-sm font-medium text-gray-900 -gray-300"
            >

                اوافق على  {<span className="text-blue-600" onClick={()=>{setModalHidden(false)}}>سياسة الخصوصية</span>}
            
            </label>
          </div>
          
          <button
            type="submit"
            className="text-white bg-brand-600 hover:bg-brand-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center -blue-600 hover:bg-blue-700 focus:ring-blue-800"
          >
            سجل
          </button>
            </form>
 <a href="https://roaait.com" // your website here
              target="_blank"
              rel="noopener noreferrer"
              className="text-white font-bold  hover:no-underline"
            >
           <div className="w-full flex justify-center mt-8">
          <div className="flex items-center gap-2 rounded-xl bg-[#A6AFD8] px-4 py-2 shadow-lg hover:scale-105 transition-transform duration-300">
            <span className="text-white text-sm sm:text-base font-semibold">
              🎉 هذا البرنامج مبني بواسطة
            </span>
           
             
              Vit
        
            <span className="text-white">🚀</span>
          </div>
        </div>
    </a>


           </div>
           <div id="crud-modal" tabIndex={-1} aria-hidden="true" className={`${modalHidden?"hidden":""} overflow-y-auto overflow-x-hidden fixed top-0 left-0 z-50  w-full  max-h-full`}>
            <div className="flex bg-gray-600 bg-opacity-90 w-[100%] h-[100vh]  justify-center items-center">
            <div className="relative py-1 px-4 w-full max-w-xl max-h-full ">
       
            <div className="relative bg-white rounded-lg shadow -gray-700">
                <div className="flex items-center justify-between p-3 md:p-3 border-b rounded-t -gray-600">
                    <h3 className="text-lg font-semibold text-gray-900 -white">
                        سياسة الخصوصية
                    </h3>
                    <button type="button"  onClick={()=>{
                            setModalHidden(true)
                        }} className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center hover:bg-gray-600 hover:text-white" data-modal-toggle="crud-modal">
                        <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                            <path stroke="currentColor" strokeLinecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                        </svg>
                        <span className="sr-only">Close modal</span>
                    </button>
                </div>
                    <div className="p-5 h-[80vh] overflow-scroll">
                      <p>
                        مرحبًا بك في {passTemplate?.organization?.name} ("نحن"، "لنا"، أو "خاصتنا"). نحن نُقدّر خصوصيتك وملتزمون بحماية معلوماتك الشخصية. توضح سياسة الخصوصية هذه كيف نجمع معلوماتك الشخصية ونستخدمها ونشاركها عند تفاعلك مع خدماتنا.
                      </p>

                      <h2>المعلومات التي نجمعها</h2>

                      <p>قد نقوم بجمع ومعالجة المعلومات الشخصية التالية:</p>
                      <ul>
                        <li><strong>الاسم:</strong> الذي تقدمه أثناء تسجيل الحساب أو التفاعل مع خدماتنا.</li>
                        <li><strong>البريد الإلكتروني:</strong> الذي تقدمه لتسهيل التواصل وتقديم الخدمات وإرسال التحديثات.</li>
                        <li><strong>رقم الهاتف:</strong> الذي تقدمه للتحقق من الحساب والتواصل وتقديم العروض المخصصة.</li>
                      </ul>

                      <h2>كيف نستخدم معلوماتك</h2>

                      <p>نستخدم المعلومات التي تقدمها للأغراض التالية:</p>
                      <ol>
                        <li><strong>تقديم الخدمات:</strong> لتوفير خدماتنا وتحسينها وتلبية الطلبات وإدارة حسابك.</li>
                        <li><strong>التسويق والاتصالات الترويجية:</strong> لإرسال التحديثات والعروض الترويجية والمحتوى التسويقي. يمكنك إلغاء الاشتراك في هذه الرسائل في أي وقت.</li>
                        <li><strong>دعم العملاء:</strong> للرد على الاستفسارات وتقديم المساعدة.</li>
                        <li><strong>الامتثال القانوني:</strong> للامتثال للقوانين واللوائح المعمول بها.</li>
                      </ol>

                      <h2>مشاركة المعلومات</h2>

                      <p>قد نشارك معلوماتك الشخصية مع الجهات التالية:</p>
                      <ul>
                        <li><strong>مزودي الخدمات:</strong> الأطراف الثالثة التي تساعدنا في تقديم الخدمات مثل خدمات البريد الإلكتروني والرسائل النصية.</li>
                        <li><strong>الجهات القانونية:</strong> عندما يُطلب منا ذلك للامتثال للالتزامات القانونية أو للاستجابة لطلبات قانونية.</li>
                        <li><strong>شركاء الأعمال:</strong> شركاء موثوقون لأغراض تسويقية، بشرط التزامهم بالسرية ومعايير حماية البيانات.</li>
                      </ul>

                      <h2>الاحتفاظ بالبيانات</h2>

                      <p>
                        نحتفظ بمعلوماتك الشخصية طالما كان ذلك ضروريًا للأغراض الموضحة في سياسة الخصوصية هذه أو كما يقتضي القانون.
                      </p>

                      <h2>حقوقك</h2>

                      <p>لديك الحقوق التالية فيما يخص معلوماتك الشخصية:</p>
                      <ul>
                        <li><strong>الوصول والنقل:</strong> طلب الوصول إلى بياناتك.</li>
                        <li><strong>التصحيح:</strong> تحديث المعلومات غير الدقيقة أو غير المكتملة.</li>
                        <li><strong>الحذف:</strong> طلب حذف بياناتك، وفقًا للمتطلبات القانونية.</li>
                        <li><strong>إلغاء الاشتراك:</strong> إلغاء الاشتراك من الاتصالات التسويقية باتباع التعليمات في رسائل البريد الإلكتروني أو التواصل معنا مباشرة.</li>
                      </ul>

                      <h2>تدابير الأمان</h2>

                      <p>نُطبق تدابير أمان قياسية لحماية معلوماتك، بما في ذلك:</p>
                      <ul>
                        <li>تشفير البيانات الحساسة.</li>
                        <li>إجراء تدقيقات أمنية منتظمة.</li>
                        <li>تقييد الوصول إلى المعلومات الشخصية.</li>
                      </ul>

                      <h2>تحديثات على هذه السياسة</h2>

                      <p>
                        قد نقوم بتحديث سياسة الخصوصية هذه من وقت لآخر. سيتم إعلامك بأي تغييرات من خلال موقعنا الإلكتروني أو قنوات أخرى مناسبة.
                      </p>

                      <h2>اتصل بنا</h2>

                      <p>
                        إذا كانت لديك أي أسئلة أو استفسارات بشأن سياسة الخصوصية هذه أو ممارساتنا، يرجى الاتصال بنا على:
                      </p>
                      <ul>
                        <li><strong>البريد الإلكتروني:</strong> {passTemplate?.organization?.email}</li>
                        <li><strong>رقم الهاتف:</strong> {passTemplate?.organization?.phone}</li>
                      </ul>

                      <p>
                        من خلال مشاركة معلوماتك الشخصية، فإنك توافق على الشروط الموضحة في سياسة الخصوصية هذه.
                      </p>
                    </div>
                    </div>
                </div>
                            </div>
                
                        </div>
            </div>
        
        
      )
  
  );
};

export default CustomerSignup;
